import RuleRowConnector from 'components/RuleRow/RuleRowConnector';

export default RuleRowConnector;
